/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Create Project Request Body
 */
export interface CreateProjectBody { 
    /**
     * The environment of the project. prod Production stage Staging dev Development
     */
    environment: CreateProjectBody.EnvironmentEnum;
    /**
     * Home Region  The home region of the project. This is the region where the project will be created. eu-central EUCentral asia-northeast AsiaNorthEast us-east USEast us-west USWest us US global Global
     */
    home_region?: CreateProjectBody.HomeRegionEnum;
    /**
     * The name of the project to be created
     */
    name: string;
    /**
     * The workspace to create the project in.
     */
    workspace_id?: string;
}
export namespace CreateProjectBody {
    export type EnvironmentEnum = 'prod' | 'stage' | 'dev';
    export const EnvironmentEnum = {
        Prod: 'prod' as EnvironmentEnum,
        Stage: 'stage' as EnvironmentEnum,
        Dev: 'dev' as EnvironmentEnum
    };
    export type HomeRegionEnum = 'eu-central' | 'asia-northeast' | 'us-east' | 'us-west' | 'us' | 'global';
    export const HomeRegionEnum = {
        EuCentral: 'eu-central' as HomeRegionEnum,
        AsiaNortheast: 'asia-northeast' as HomeRegionEnum,
        UsEast: 'us-east' as HomeRegionEnum,
        UsWest: 'us-west' as HomeRegionEnum,
        Us: 'us' as HomeRegionEnum,
        Global: 'global' as HomeRegionEnum
    };
}


